const ab = [
  {
    TestJSON:
      '{"ID":6859763,"TestType":"ATEST","Title":"医院污物的处理原则错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["防止污染扩散","分类收集","分别处理","少量医疗垃圾可与生活垃圾一同处理","尽可能采用焚烧处理"],"Answer":"D","Sorting":5}',
    Style: "A型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859773,"TestType":"ATEST","Title":"经血液、体液传播的病原体不包括(   )","Explain":"","TestPoint":"","SelectedItem":["乙型肝炎病毒","丙型肝炎病毒","人类免疫缺陷病毒","麻疹病毒","疟原虫"],"Answer":"D","Sorting":15}',
    Style: "A型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859820,"TestType":"ATEST","Title":"关于地面和拖洗工具的消毒，下列哪项是正确的(   )","Explain":"","TestPoint":"","SelectedItem":["地面应经常用含氯消毒剂拖洗，既能消毒，又能增白","因为2%戊二醛是高水平消毒剂，有条件时最好用戊二醛拖地，消毒效果好","拖洗工具使用后先洗净，再消毒，然后晾干","地面应湿式清扫，保持清洁，局部有血迹等污染时局部用消毒剂处理","检验科的地面每天均需用消毒剂拖洗"],"Answer":"D","Sorting":7}',
    Style: "A型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859766,"TestType":"ATEST","Title":"病房的医院内感染管理措施中错误的是","Explain":"","TestPoint":"","SelectedItem":["感染病人与非感染病人分开","同类感染病人相对集中","特殊感染病人单独安置","室内应定时通风换气，必要时进行空气消毒","地面应常规使用含氯消毒剂消毒"],"Answer":"E","Sorting":8}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859819,"TestType":"ATEST","Title":"下述关于医院内感染知识培训的要求，哪一项是错误的(   )","Explain":"","TestPoint":"","SelectedItem":["培训内容包括管理知识和专业知识","培训对象包括管理、医务、工勤人员","非专职人员每年不少于2小时培训","进修医师必须培训","实习医师必须培训"],"Answer":"C","Sorting":6}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859823,"TestType":"ATEST","Title":"细菌耐药最常见的机制是(   )","Explain":"","TestPoint":"","SelectedItem":["产生抗生素灭活酶","抗菌药物作用靶位改变","细菌改变代谢途径","细菌细胞膜渗透性改变，使抗菌药物不易进入细菌细胞","细菌细胞将抗菌药物排除细菌"],"Answer":"A","Sorting":10}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861034,"TestType":"ATEST","Title":"临床医师的地位，在全面康复中应当是(   )","Explain":"","TestPoint":"","SelectedItem":["康复二级预防的组织者和执行者","康复医疗的执行者","康复三级预防的组织者","负责住院病人的医疗康复者","全面康复的执行者"],"Answer":"A","Sorting":1}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861043,"TestType":"ATEST","Title":"影响红斑反应强度的因素，以下说法何者错误(   )","Explain":"","TestPoint":"","SelectedItem":["病人全身营养状况不佳时红斑反应减弱","15天以前的新生儿几乎不产生红斑反应","皮肤色素含量不同，红斑阈值相同","同一人身体各部位的皮肤对紫外线的敏感性不同","小儿红斑反应消失得较快"],"Answer":"C","Sorting":10}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861049,"TestType":"ATEST","Title":"神经纤维生长速度平均为(   )","Explain":"","TestPoint":"","SelectedItem":["1～2mm/d","2.5mm/d","3mm/d","3～4mm/d","O.5～5mm/d"],"Answer":"E","Sorting":16}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861103,"TestType":"ATEST","Title":"关于红斑的叙述，下述何者错误(   )","Explain":"","TestPoint":"","SelectedItem":["皮肤接受一定剂量的紫外线后，被照射区皮肤立即显现红斑，称为红斑反应","紫外线照射剂量越大，红斑潜伏期越短","长波紫外线的照射剂量越大，红斑潜伏期越长","紫外线剂量小时，红斑持续时间短","紫外线波长297nm引起的红斑反应最明显"],"Answer":"A","Sorting":9}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861112,"TestType":"ATEST","Title":"徒手肌力检查最适合(   )","Explain":"","TestPoint":"","SelectedItem":["脑瘫病人","脑卒中病人","周围神经损伤病人","帕金森病病人","脑外伤后遗症病人"],"Answer":"C","Sorting":18}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859315,"TestType":"ATEST","Title":"生命伦理学的研究领域不包括(   )","Explain":"","TestPoint":"","SelectedItem":["临床生命伦理学","理论生命伦理学","心理生命伦理学","科技生命伦理学","文化生命伦理学"],"Answer":"C","Sorting":1}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859359,"TestType":"ATEST","Title":"影响和制约医疗水平的因素不包括(   )","Explain":"","TestPoint":"","SelectedItem":["科技发展水平","医务人员的道德水平","病人的合作程度","卫生政策和制度的合理性","医务人员的技术水平"],"Answer":"C","Sorting":0}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861098,"TestType":"ATEST","Title":"以下几种常见的病理步态哪项描述是正确的(   )","Explain":"","TestPoint":"","SelectedItem":["减痛步常见于足下垂","回旋步常见于偏瘫病人足内翻","剪刀步常见于小儿麻痹后遗症","斜肩步常见于股四头肌瘫痪","前冲步常见于小脑性共济失调"],"Answer":"B","Sorting":4}',
    Style: "A型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859324,"TestType":"XTEST","Title":"按照记忆的分类，下述哪些属于记忆的内容(   )","Explain":"略","TestPoint":"","Sorting":6,"SelectedItem":["形象记忆","强迫记忆","运动记忆","逻辑记忆","情绪记忆"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861063,"TestType":"XTEST","Title":"常用的反射疗法区有(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["鼻黏膜区","披肩区","腰骶区","心前区","头顶区"],"Answer":"ABC"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859319,"TestType":"XTEST","Title":"道德的特点包括(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["稳定性","规范性","天赋性","社会性","层次性"],"Answer":"BCE"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861062,"TestType":"XTEST","Title":"肌力测定的意义包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["了解损伤和疾病导致肌力减退的范围","了解损伤和疾病导致肌力减退的程度","评定治疗效果","制定治疗方案依据","判定预后"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859319,"TestType":"XTEST","Title":"道德的特点包括(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["稳定性","规范性","天赋性","社会性","层次性"],"Answer":"BCE"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859373,"TestType":"XTEST","Title":"道德的含义包括(   )","Explain":"略","TestPoint":"","Sorting":11,"SelectedItem":["道德水平","道德意识","道德范围","道德伦理","道德实践"],"Answer":"BCE"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861123,"TestType":"XTEST","Title":"关节活动度检查的注意事项有(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["防止邻近关节的替代动作","需测关节的主动活动范围和被动活动范围","与健侧对比","允许有3°～5°的误差","按摩、运动后立即进行"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861123,"TestType":"XTEST","Title":"关节活动度检查的注意事项有(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["防止邻近关节的替代动作","需测关节的主动活动范围和被动活动范围","与健侧对比","允许有3°～5°的误差","按摩、运动后立即进行"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861060,"TestType":"XTEST","Title":"运动疗法的注意事项中，以下哪些是正确的(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["掌握好适应证","运动到稍感疲劳时，应终止运动","循序渐进、持之以恒","对暂无条件进行运动试验确定运动强度者，以一次运动后心率不超过120～130次/min为宜","衣着要合身，避免穿过紧过小的衣服，以免影响循环和活动"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859342,"TestType":"PDTEST","Title":"在特殊情况下，为了查清死者的病因，判断诊断治疗的谬误，有利于医学科学的发展，虽未征得死者生前同意或家属的首肯，经有关特定部门的批准，也可以进行尸体解剖。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":3}',
    Style: "判断题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861147,"TestType":"PDTEST","Title":"临床上常见的继发性骨质疏松有急发偏瘫、脑瘫、精神分裂症。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":7}',
    Style: "判断题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871912,"TestType":"PDTEST","Title":"输血科的储血冰箱应专用于储存血液及血液成分，不定期清洁和消毒，防止污染。每季度对冰箱的内壁进行生物学监测，不得检出致病性微生物和真菌。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":2}',
    Style: "判断题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859339,"TestType":"PDTEST","Title":"医学伦理与医学道德是相同的概念，两词可以通用。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":0}',
    Style: "判断题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859851,"TestType":"PDTEST","Title":"输血科的储血冰箱应专用于储存血液及血液成分，不定期清洁和消毒，防止污染。每季度对冰箱的内壁进行生物学监测，不得检出致病性微生物和真菌。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":2}',
    Style: "判断题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861083,"TestType":"PDTEST","Title":"胫神经受损后常出现跟行足。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":9}',
    Style: "判断题",
    errCount: 1,
    AlreadyStuCount: 1,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859780,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["醋酸氯己定","新洁尔灭","两者均是","两者均否"],"BTestItem":[{"ID":1272,"TestType":"ATEST","Title":"属于低效消毒剂的是(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1273,"TestType":"ATEST","Title":"属于高效消毒剂的是(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1}]}',
    Style: "B型题",
    errCount: 4,
    AlreadyStuCount: 4,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871397,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["神经痛","小儿骨骺部","冠心病","关节僵直","带有心脏起搏器者"],"BTestItem":[{"ID":1000714,"TestType":"ATEST","Title":"超声治疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":0},{"ID":1000715,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[E]","Sorting":1}]}',
    Style: "B型题",
    errCount: 4,
    AlreadyStuCount: 4,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859780,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["醋酸氯己定","新洁尔灭","两者均是","两者均否"],"BTestItem":[{"ID":1272,"TestType":"ATEST","Title":"属于低效消毒剂的是(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1273,"TestType":"ATEST","Title":"属于高效消毒剂的是(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1}]}',
    Style: "B型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861056,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["脊髓损伤后髓骶节段S4～S5无任何运动感觉功能保留","脊髓损伤平面以下有运动功能的保留，而且主要特征关键肌肉(keymlascle)的肌力在3级或3级以上","脊髓损伤平面以下有运动功能的保留，但主要特征关键肌肉(keymuscle)的肌力在3级以下","脊髓损伤平面以下包括髓骶节段S4～S5（鞍区）无任何运动功能保留，而有感觉功能残留","运动、感觉功能正常"],"BTestItem":[{"ID":1527,"TestType":"ATEST","Title":"B级损伤(ASIA标准)是指(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1528,"TestType":"ATEST","Title":"D级损伤(ASIA标准)是指(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "B型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6861056,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["脊髓损伤后髓骶节段S4～S5无任何运动感觉功能保留","脊髓损伤平面以下有运动功能的保留，而且主要特征关键肌肉(keymlascle)的肌力在3级或3级以上","脊髓损伤平面以下有运动功能的保留，但主要特征关键肌肉(keymuscle)的肌力在3级以下","脊髓损伤平面以下包括髓骶节段S4～S5（鞍区）无任何运动功能保留，而有感觉功能残留","运动、感觉功能正常"],"BTestItem":[{"ID":1527,"TestType":"ATEST","Title":"B级损伤(ASIA标准)是指(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1528,"TestType":"ATEST","Title":"D级损伤(ASIA标准)是指(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "B型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871898,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["0.5%碘伏","2%戊二醛","两者均是","两者均否"],"BTestItem":[{"ID":1000818,"TestType":"ATEST","Title":"低效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1000819,"TestType":"ATEST","Title":"高效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "C型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871899,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["使用过的注射针头","带血的敷料","两者均是","两者均否"],"BTestItem":[{"ID":1000820,"TestType":"ATEST","Title":"医疗废物为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000821,"TestType":"ATEST","Title":"损伤性废物为（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":1},{"ID":1000822,"TestType":"ATEST","Title":"生活垃圾为（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 3,
    AlreadyStuCount: 3,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871843,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["醋酸氯己定","苯扎溴铵","两者均是","两者均否"],"BTestItem":[{"ID":1000803,"TestType":"ATEST","Title":"低效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000804,"TestType":"ATEST","Title":"高效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1}]}',
    Style: "C型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871899,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["使用过的注射针头","带血的敷料","两者均是","两者均否"],"BTestItem":[{"ID":1000820,"TestType":"ATEST","Title":"医疗废物为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000821,"TestType":"ATEST","Title":"损伤性废物为（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":1},{"ID":1000822,"TestType":"ATEST","Title":"生活垃圾为（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 3,
    AlreadyStuCount: 3,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871401,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["恶性肿瘤","活动性结核","两者均是","两者均否"],"BTestItem":[{"ID":1000722,"TestType":"ATEST","Title":"超声治疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000723,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":1}]}',
    Style: "C型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871843,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["醋酸氯己定","苯扎溴铵","两者均是","两者均否"],"BTestItem":[{"ID":1000803,"TestType":"ATEST","Title":"低效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000804,"TestType":"ATEST","Title":"高效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1}]}',
    Style: "C型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871899,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["使用过的注射针头","带血的敷料","两者均是","两者均否"],"BTestItem":[{"ID":1000820,"TestType":"ATEST","Title":"医疗废物为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000821,"TestType":"ATEST","Title":"损伤性废物为（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":1},{"ID":1000822,"TestType":"ATEST","Title":"生活垃圾为（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 3,
    AlreadyStuCount: 3,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859361,"TestType":"ATEST","Title":"下列哪项不属于人类的生理需要(   )","Explain":"","TestPoint":"","SelectedItem":["饥","渴","美","性","排泄"],"Answer":"C","Sorting":2}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859761,"TestType":"ATEST","Title":"下列消毒剂中属中效消毒剂的是(   )","Explain":"","TestPoint":"","SelectedItem":["戊二醛","过氧乙酸","氯己定","臭氧","碘伏"],"Answer":"E","Sorting":3}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859771,"TestType":"ATEST","Title":"传染性非典型肺炎的最主要传播途径是(   )","Explain":"","TestPoint":"","SelectedItem":["经呼吸道飞沫传播","经消化道传播","经粪-口途径传播","接触传播","虫媒传播"],"Answer":"A","Sorting":13}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859818,"TestType":"ATEST","Title":"下列消毒剂中属高水平消毒剂的是(   )","Explain":"","TestPoint":"","SelectedItem":["戊二醛","络合碘","苯扎溴胺","乙醇","碘酊"],"Answer":"A","Sorting":5}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861038,"TestType":"ATEST","Title":"下列哪项是脊髓型颈椎病临床常见的症状与体征(   )","Explain":"","TestPoint":"","SelectedItem":["头痛、头晕","手麻、烧灼感","肌萎缩、腱反射减弱","肩臂痛、麻木","颈肩痛、下肢笨拙、Hoffman征阳性"],"Answer":"E","Sorting":5}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861040,"TestType":"ATEST","Title":"下列哪项不是椎动脉型颈椎病主要症状(   )","Explain":"","TestPoint":"","SelectedItem":["眩晕性恶心、呕吐","耳鸣耳聋","手肿胀、心悸、血压不稳","突然摔倒","颈酸胀痛"],"Answer":"E","Sorting":7}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861100,"TestType":"ATEST","Title":"选择离子导入药物的原则，下述何者错误(   )","Explain":"","TestPoint":"","SelectedItem":["必须选择用量较小即能生效的药物","药物离子或胶体微粒的直径必须明显小于汗腺排泄孔的口径","药物成分可含寄生离子","药物在局部应用时也有疗效","贵重药物一般不宜大量作直流电导入"],"Answer":"C","Sorting":6}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861101,"TestType":"ATEST","Title":"关于离子导入的优缺点，下述何者错误(   )","Explain":"","TestPoint":"","SelectedItem":["透热较深但不损伤皮肤","导入药物剂量少，不能代替口服或注射药","导入药物在局部能保持较高的浓度","导入机体起主要药理作用的是纯药物离子","用直流电导入机体的药物，在体内保留的时间较长"],"Answer":"A","Sorting":7}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861107,"TestType":"ATEST","Title":"下述哪项不属骨质疏松抗骨吸收药(   )","Explain":"","TestPoint":"","SelectedItem":["雌激素、孕激素","钙制剂","芬必得、吲哚美辛","降钙素","维生素D"],"Answer":"C","Sorting":13}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861109,"TestType":"ATEST","Title":"下述哪项不是中枢神经系统可塑性理论中强调功能训练作用的原因(   )","Explain":"","TestPoint":"","SelectedItem":["提高过去相对无效的通路","提高新形成的突触效率","要求对原先不承担某种功能的结构去承担新的不熟悉的任务","通过反复学习、接收和利用外周刺激的感觉反馈","通过巨细胞释放细胞素"],"Answer":"E","Sorting":15}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871393,"TestType":"ATEST","Title":"康复评估的特点是（   ）","Explain":"","TestPoint":"","SelectedItem":["重点是与生活自理、学习、劳动有关的综合功能评估","重点是运动能力的评估","主要是医学心理学的检查","职业能力的评估","针对病因的评估"],"Answer":"A","Sorting":3}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871834,"TestType":"ATEST","Title":"传染性非典型肺炎的最主要传播途径是（   ）","Explain":"","TestPoint":"","SelectedItem":["经呼吸道飞沫传播","经消化道传播","经粪-口途径传播","接触传播","虫媒传播"],"Answer":"A","Sorting":13}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859772,"TestType":"ATEST","Title":"关于消毒因子对人体的危害，错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["微波对人体无害","液体消毒剂可以造成人体过敏","紫外线直接照射可伤害人体皮肤和角膜","环氧乙烷泄漏不仅对人体直接有毒，还可以发生爆炸","吸入戊二醛气体对人体有害"],"Answer":"A","Sorting":14}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861037,"TestType":"ATEST","Title":"下述哪项不是上肢运动功能检查项目(   )","Explain":"","TestPoint":"","SelectedItem":["拇、示、中指抓握、侧捏","拇指与其他各指的对捏","前臂的旋前旋后功能","运用上肢放置物体","两点分辨位置"],"Answer":"E","Sorting":4}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861039,"TestType":"ATEST","Title":"下列哪项不是神经根型颈椎病症状(   )","Explain":"","TestPoint":"","SelectedItem":["颈僵活动受限","头、枕、颈痛","手麻","下肢无力、步态不稳、手足颤动","肘部痛、胀"],"Answer":"D","Sorting":6}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871396,"TestType":"ATEST","Title":"下列哪项不是超短波疗法的绝对禁忌证（   ）","Explain":"","TestPoint":"","SelectedItem":["月经期下腹部","使用足够剂量抗肿瘤药的癌症病人","带有人工心脏起搏器","机体极度衰弱者","高热病人"],"Answer":"B","Sorting":6}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871821,"TestType":"ATEST","Title":"传染病房医院内感染控制措施中错误的是（   ）","Explain":"","TestPoint":"","SelectedItem":["严格执行消毒隔离制度","不同传染病可安排在同一房间","病房内污染区、半污染区、相对清洁区分区明确","病人的排泄物、分泌物、病房污水必须经过消毒处理后方可排放，固体污物应进行无害化处理或焚烧","严格探视、陪住制度"],"Answer":"B","Sorting":0}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871826,"TestType":"ATEST","Title":"医院污物的处理原则，下述哪项是错误的（   ）","Explain":"","TestPoint":"","SelectedItem":["防止污染扩散","分类收集","分别处理","少量医疗垃圾可与生活垃圾一同处理","尽可能采用焚烧处理"],"Answer":"D","Sorting":5}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871832,"TestType":"ATEST","Title":"下列内镜需灭菌，但除外（   ）","Explain":"","TestPoint":"","SelectedItem":["纤维支气管镜","腹腔镜","脑室镜","关节镜","胸腔镜"],"Answer":"A","Sorting":11}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871833,"TestType":"ATEST","Title":"关于锐器伤的预防，错误的是（   ）","Explain":"","TestPoint":"","SelectedItem":["如不慎发生锐器伤，应立即采取相应的保护措施，清创，对创面进行严格消毒处理","对发生锐器伤者进行血源性疾病的检查和随访","被HBV阳性病人血液、体液污染了的锐器刺伤，应在1周内注射乙型肝炎高效价免疫球蛋白","被HBV阳性病人血液、体液污染的锐器刺伤，应进行血液乙型肝炎标志物检查","被HBV阳性病人血液、体液污染了的锐器刺伤，血液乙型肝炎标志物阴性者按规定接种乙型肝炎疫苗"],"Answer":"C","Sorting":12}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871838,"TestType":"ATEST","Title":"除灭菌速度快、灭菌效果好、经济、环境污染小的压力蒸气灭菌法外，目前最常用的低温灭菌方法是（   ）","Explain":"","TestPoint":"","SelectedItem":["环氧乙烷灭菌法","戊二醛浸泡灭菌法","辐射灭菌法","过氧乙酸浸泡灭菌法","微波灭菌法"],"Answer":"A","Sorting":17}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871880,"TestType":"ATEST","Title":"关于使用中的消毒剂、灭菌剂的监测，下列哪项是错误的（   ）","Explain":"","TestPoint":"","SelectedItem":["应进行生物和化学监测","生物监测：消毒剂每季度1次，其细菌含量必须<100cfu/mL，不得检出致病性微生物","灭菌剂每月生物监测1次，不得检出任何微生物","含氯消毒剂、过氧乙酸等的浓度应每天监测","对戊二醛浓度的监测应每月不少于1次"],"Answer":"E","Sorting":4}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859317,"TestType":"ATEST","Title":"有关医德监督的方式，下列哪项是错误的(   )","Explain":"","TestPoint":"","SelectedItem":["法律监督","舆论监督","群众监督","领导监督","自我监督"],"Answer":"D","Sorting":3}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859768,"TestType":"ATEST","Title":"输液反应中属于医院感染的是(   )","Explain":"","TestPoint":"","SelectedItem":["由液体或输液通路中的毒素引起的发热","由于液体被细菌污染引起的发热","由于输注液体中的药物引起的发热","由于输液管中的内毒素引起的发热","由于输注的液体中含有热源物质引起的发热"],"Answer":"B","Sorting":10}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859769,"TestType":"ATEST","Title":"下列内镜使用前需灭菌处理，但除外(   )","Explain":"","TestPoint":"","SelectedItem":["纤维支气管镜","腹腔镜","脑室镜","关节镜","胸腔镜"],"Answer":"A","Sorting":11}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859770,"TestType":"ATEST","Title":"关于锐器伤的预防措施，错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["如不慎发生锐器伤，应立即采取相应的保护措施，清创，对创面进行严格消毒处理","被HBV阳性病人血液、体液污染了的锐器刺伤，应在1周内注射乙型肝炎高效价免疫球蛋白","对发生锐器伤者进行血源性疾病的检查和随访","被HBV阳性病人血液、体液污染的锐器刺伤，应进行血液乙型肝炎标志物检查","被HBV阳性病人血液、体液污染了的锐器刺伤，血液乙型肝炎标志物阴性者按规定接种乙型肝炎疫苗"],"Answer":"B","Sorting":12}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859827,"TestType":"ATEST","Title":"对预防传染性非典型肺炎无效的公众预防措施是(   )","Explain":"","TestPoint":"","SelectedItem":["在通风不好或人群密集的场所戴口鼻罩","勤洗手","讲究个人卫生","注射丙种球蛋白","不接触传染性非典型病人或临床诊断病人"],"Answer":"D","Sorting":14}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859831,"TestType":"ATEST","Title":"引起输血后肝炎的主要肝炎病毒为(   )","Explain":"","TestPoint":"","SelectedItem":["甲型肝炎病毒","乙型肝炎病毒","丙型肝炎病毒","戊型肝炎病毒","庚型肝炎病毒"],"Answer":"C","Sorting":18}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861035,"TestType":"ATEST","Title":"康复评定的目的是(   )","Explain":"","TestPoint":"","SelectedItem":["客观地找到病因","客观地判定疗效","为残损功能障碍定性","评定功能障碍程度","作为了解功能障碍的性质、部位、范围、程度、趋势、预后和结局及评定疗效和治疗计划的依据"],"Answer":"E","Sorting":2}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861044,"TestType":"ATEST","Title":"有关石蜡疗法，下述何者不当(   )","Explain":"","TestPoint":"","SelectedItem":["溶解石蜡须采用隔水加热的方法","石蜡中的油质和其冷却凝固时对皮肤的压缩能使皮肤保持弹性和柔软","用过的石蜡可重复使用，但须清除其中汗、泥和脱落的皮肤污秽物","目前蜡疗尚无绝对禁忌证","蜡疗能明显影响机体的代谢过程，使局部和深部组织温度升高"],"Answer":"D","Sorting":11}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871391,"TestType":"ATEST","Title":"康复的对象是（   ）","Explain":"","TestPoint":"","SelectedItem":["截瘫、偏瘫病人","智力低下、语言障碍的病人","各种功能障碍的病人","心肺功能障碍的病人","脊髓灰质炎、精神病病人"],"Answer":"C","Sorting":1}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871394,"TestType":"ATEST","Title":"矫形器的使用目的是（   ）","Explain":"","TestPoint":"","SelectedItem":["主要是预防或矫正畸形，减轻疼痛，补偿功能活动，支承体重，稳定肢体","主要是防止骨折和扭伤","主要是为了加强肌力训练，发展肌肉","主要是用于各种手术的保护","主要用于纠正足下垂"],"Answer":"A","Sorting":4}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871836,"TestType":"ATEST","Title":"经血液、体液传播的病原体不包括（   ）","Explain":"","TestPoint":"","SelectedItem":["乙型肝炎病毒","丙型肝炎病毒","人类免疫缺陷病毒","麻疹病毒","疟原虫"],"Answer":"D","Sorting":15}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871884,"TestType":"ATEST","Title":"关于输血科预防医院内感染的措施，下列哪项是错误的（   ）","Explain":"","TestPoint":"","SelectedItem":["保持环境清洁，每天清洁桌面","被血液污染的台面可用苯扎溴铵消毒处理","工作人员上岗前应注射乙型肝炎疫苗，并定期检查抗体水平","血浆置换术应在Ⅱ类环境中进行并注意消毒隔离","每月对储血冰箱的内壁进行生物学监测，不得检出致病性微生物和真菌"],"Answer":"B","Sorting":8}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859760,"TestType":"ATEST","Title":"关于医院内感染的概念，错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["医院内感染是指在医院内获得的感染","病人入院时处于潜伏期的感染一定不是医院内感染","病人出院之后发生的感染可能不是医院内感染","与上次住院有关的感染是医院内感染","婴幼儿经胎盘获得的感染是医院内感染"],"Answer":"E","Sorting":2}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859777,"TestType":"ATEST","Title":"下列有关护理工作的描述，不正确的是(   )","Explain":"","TestPoint":"","SelectedItem":["各种治疗、护理、换药操作应按清洁伤口、感染伤口、隔离伤口依次进行","起封抽吸的各种溶媒超过36小时不得使用，最好采用大包装","无菌物品必须一人一用一灭菌","灭菌物品提倡使用小包装，无菌棉球或纱布罐一经打开，使用时间不得超过24小时","治疗室、处置室布局合理，清洁区、污染区分区明确"],"Answer":"B","Sorting":19}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859814,"TestType":"ATEST","Title":"治疗室的管理中，下列哪项是错误的(   )","Explain":"","TestPoint":"","SelectedItem":["注射治疗时要铺无菌盘，抽出的药液存放不能超过2小时","治疗室中开启的各种溶酶超过24个小时不能使用，最好采用小包装","治疗室中开启的无菌溶液需在2小时内使用","碘酊、酒精瓶应保持密闭，每周更换并对容器灭菌1～2次","经灭菌后的棉球、纱布包一经打开，使用时间不能超过48小时"],"Answer":"E","Sorting":1}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861052,"TestType":"ATEST","Title":"Barthel指数量表评分项目共10项100分，60～40分者为(   )","Explain":"","TestPoint":"","SelectedItem":["生活基本自理","生理需要帮助","生活依赖明显","生活需要安全依赖","生活需很大帮助"],"Answer":"B","Sorting":19}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861095,"TestType":"ATEST","Title":"康复的对象是(   )","Explain":"","TestPoint":"","SelectedItem":["截瘫、偏瘫病人","智力低下、语言障碍的病人","各种功能障碍的人","心肺功能障碍的病人","小儿麻痹症、精神病病人"],"Answer":"C","Sorting":1}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861104,"TestType":"ATEST","Title":"关于全身药物浴，下述错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["盐水浴常用于多发性关节炎、肌炎","松脂浴常用于原发性高血压Ⅰ期","苏打浴常用于银屑病、皮肤角质层增厚","中药浴常用于关节炎、皮肤病","西药浴（安定）常用于神经衰弱"],"Answer":"E","Sorting":10}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861105,"TestType":"ATEST","Title":"下述哪项不是脑瘫发生的危险因素(   )","Explain":"","TestPoint":"","SelectedItem":["孕龄34～36周","低体重(<2500g)","胎盘早剥","胎儿畸形","胎儿窒息"],"Answer":"A","Sorting":11}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861106,"TestType":"ATEST","Title":"下述哪项不是脑瘫常见的临床表现(   )","Explain":"","TestPoint":"","SelectedItem":["运动障碍，肌张力增高","姿势异常","语言障碍","行为异常","感觉异常"],"Answer":"E","Sorting":12}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871392,"TestType":"ATEST","Title":"下列哪项不是康复护理的主要内容（   ）","Explain":"","TestPoint":"","SelectedItem":["改善功能障碍的护理","功能训练的护理","心理护理","”替代护理”","专业技术护理"],"Answer":"D","Sorting":2}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871823,"TestType":"ATEST","Title":"关于医院内感染的概念，错误的是（   ）","Explain":"","TestPoint":"","SelectedItem":["医院内感染是指在医院内获得的感染","与上次住院有关的感染是医院内感染","出院之后发生的感染可能不是医院内感染","入院时处于潜伏期的感染一定不是医院内感染","婴幼儿经胎盘获得的感染是医院内感染"],"Answer":"E","Sorting":2}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871825,"TestType":"ATEST","Title":"以15%过氧乙酸原液配制0.3%过氧乙酸100mL，下列方法中正确的是（   ）","Explain":"","TestPoint":"","SelectedItem":["原液稀释200倍","原液30mL加水70mL","原液20mL加水80mL","原液15mL加水85mL","原液2mL加水98mL"],"Answer":"E","Sorting":4}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871890,"TestType":"ATEST","Title":"对传染性非典型肺炎无效的公众预防措施是（   ）","Explain":"","TestPoint":"","SelectedItem":["讲究个人卫生","注射丙种球蛋白","在通风不好或人群密集的场所戴口鼻罩","勤洗手","不接触传染性非典型病人或临床诊断病人"],"Answer":"B","Sorting":14}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871894,"TestType":"ATEST","Title":"目前引起输血后肝炎的主要肝炎病毒为（   ）","Explain":"","TestPoint":"","SelectedItem":["甲型肝炎病毒","乙型肝炎病毒","丙型肝炎病毒","戊型肝炎病毒","庚型肝炎病毒"],"Answer":"C","Sorting":18}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859314,"TestType":"ATEST","Title":"有关生命医学伦理学基本原则的描述，错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["不伤害","保护","尊重","公正","有利"],"Answer":"B","Sorting":0}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859316,"TestType":"ATEST","Title":"诊治伤害现象的划分应不包括(   )","Explain":"","TestPoint":"","SelectedItem":["有意伤害","可知伤害","免责伤害","责任伤害","可控伤害"],"Answer":"C","Sorting":2}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859360,"TestType":"ATEST","Title":"下列各项中不属于医师权利的是(   )","Explain":"","TestPoint":"","SelectedItem":["诊治病人的疾病权","宣告病人的死亡权","对病人的隔离权","对病人实施”安乐死”的权","医师的干涉权"],"Answer":"D","Sorting":1}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859758,"TestType":"ATEST","Title":"传染病房医院内感染控制措施中错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["严格执行消毒隔离制度","不同传染病可安排在同一房间","病房内污染区、半污染区、相对清洁区分区明确","病人的排泄物、分泌物、病房污水必须经过消毒处理后方可排放，固体污物应进行无害化处理或焚烧","严格探视、陪住制度"],"Answer":"B","Sorting":0}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859759,"TestType":"ATEST","Title":"发生医院内尿路感染最常见的诱因是(   )","Explain":"","TestPoint":"","SelectedItem":["长期卧床","留置导尿管","膀胱冲洗","膀胱内注药","膀胱镜检查"],"Answer":"B","Sorting":1}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859774,"TestType":"ATEST","Title":"有关医院内感染预防与控制的概念，错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["部分医院内感染是可以预防的","医院内感染一定是由于消毒隔离缺陷所致","洗手是预防医院内感染的重要措施","内源性医院内感染是医院内感染的重要原因","滥用抗菌药物可致二重感染"],"Answer":"B","Sorting":16}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859813,"TestType":"ATEST","Title":"医院内感染常规监测中下列哪项是错误的(   )","Explain":"","TestPoint":"","SelectedItem":["高危科室、高危人群监测","漏报率监测","高危因素监测","暴发流行监测","传染病报告卡监测"],"Answer":"E","Sorting":0}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859832,"TestType":"ATEST","Title":"对怀疑医院内感染的病例取标本进行病原体检查，错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["在使用抗菌药物前送标本","为节约经费，应该在抗感染治疗效果不佳时取标本做病原体检查","采集标本后及时送检","采集标本时防止污染","接到临床标本后及时正确接种"],"Answer":"B","Sorting":19}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871822,"TestType":"ATEST","Title":"发生医院内尿路感染最常见的诱因是（   ）","Explain":"","TestPoint":"","SelectedItem":["长期卧床","留置导尿管","膀胱冲洗","膀胱内注药","膀胱镜检查"],"Answer":"B","Sorting":1}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871824,"TestType":"ATEST","Title":"下列消毒剂中属中效消毒剂的是（   ）","Explain":"","TestPoint":"","SelectedItem":["戊二醛","过氧乙酸","氯己定","臭氧","碘伏"],"Answer":"E","Sorting":3}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871829,"TestType":"ATEST","Title":"病房的医院内感染管理措施中错误的是（   ）","Explain":"","TestPoint":"","SelectedItem":["感染病人与非感染病人分开","同类感染病人相对集中","特殊感染病人单独安置","室内应定时通风换气，必要时进行空气消毒","地面应常规使用含氯消毒剂消毒"],"Answer":"E","Sorting":8}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871877,"TestType":"ATEST","Title":"治疗室的管理中，下列哪项是错误的（   ）","Explain":"","TestPoint":"","SelectedItem":["注射治疗时要铺无菌盘，抽出的药液存放不能超过2小时","治疗室中开启的各种溶酶超过24个小时不能使用，最好采用小包装","治疗室中开启的无菌溶液需在2小时内使用","碘酊、乙醇瓶应保持密闭，每周更换并对容器灭菌1～2次","经灭菌后的棉球、纱布包一经打开，使用时间不能超过48小时"],"Answer":"E","Sorting":1}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871879,"TestType":"ATEST","Title":"医院内感染主要发生在（   ）","Explain":"","TestPoint":"","SelectedItem":["门诊、急诊病人","探视者","医务人员","住院病人","陪护人员"],"Answer":"D","Sorting":3}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871883,"TestType":"ATEST","Title":"关于地面和拖洗工具的消毒，下列哪项是正确的（   ）","Explain":"","TestPoint":"","SelectedItem":["地面应经常用含氯消毒剂拖洗，既能消毒，又能增白","因为2%戊二醛是高水平消毒剂，有条件时最好用戊二醛拖地，消毒效果好","地面应湿式清扫，保持清洁，局部有血迹等污染时，应局部用消毒剂处理","拖洗工具使用后先洗净，再消毒，然后晾干","检验科的地面每天均需用消毒剂拖洗"],"Answer":"C","Sorting":7}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859776,"TestType":"ATEST","Title":"关于消毒灭菌方法的选择，错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["耐热耐湿的物品首选压力蒸气灭菌法灭菌","手术器具与物品首选压力蒸气灭菌法灭菌","消毒首选物理方法，不能用物理方法消毒时选择化学消毒方法消毒","不耐热的物品如各种导管、精密仪器、人工移植物可以选择化学灭菌方法，如环氧乙烷灭菌","化学灭菌剂浸泡灭菌方便实用，应加以推广"],"Answer":"E","Sorting":18}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859816,"TestType":"ATEST","Title":"医院内感染主要发生在(   )","Explain":"","TestPoint":"","SelectedItem":["门诊、急诊病人","探视者","医务人员","住院病人","陪护人员"],"Answer":"D","Sorting":3}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859821,"TestType":"ATEST","Title":"关于输血科预防医院内感染的措施，下列哪项是错误的(   )","Explain":"","TestPoint":"","SelectedItem":["保持环境清洁，每天清洁桌面","被血液污染的台面可用新洁尔灭消毒处理","血浆置换术应在Ⅱ类环境中进行并注意消毒隔离","工作人员上岗前应注射乙型肝炎疫苗，并定期检查抗体水平","每月对储血冰箱的内壁进行生物学监测，不得检出致病性微生物和真菌"],"Answer":"B","Sorting":8}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861033,"TestType":"ATEST","Title":"康复医学是以下列哪方面内容为主导(   )","Explain":"","TestPoint":"","SelectedItem":["功能障碍恢复","心理疏导","疾病","人体完整","辅助矫形器应用"],"Answer":"A","Sorting":0}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861051,"TestType":"ATEST","Title":"康复的对象为(   )","Explain":"","TestPoint":"","SelectedItem":["截瘫、偏瘫病人","智力低下、语言障碍病人","各种功能障碍病人","心肺功能障碍病人","小儿麻痹症、精神病病人"],"Answer":"C","Sorting":18}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861108,"TestType":"ATEST","Title":"以下促骨形成药中何者不是主要的(   )","Explain":"","TestPoint":"","SelectedItem":["雄激素、前列腺素","氟化物","骨生长因子","依普黄酮","B族维生素"],"Answer":"E","Sorting":14}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861110,"TestType":"ATEST","Title":"下述哪项不是人们赖以生存的主要能力(   )","Explain":"","TestPoint":"","SelectedItem":["对周围环境的辨时、辨向、辨人","富有的财富","个人生活自理和社会活动能力","步行、利用轮椅及交通工具活动，能进行家务、娱乐活动","能劳动就业"],"Answer":"B","Sorting":16}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871830,"TestType":"ATEST","Title":"下列细菌是目前医院内感染常见的细菌，但除外（   ）","Explain":"","TestPoint":"","SelectedItem":["葡萄球菌特别是金黄色葡萄球菌和凝固酶阴性葡萄球菌","大肠埃希菌","沙门菌属","铜绿假单胞菌","肺炎杆菌"],"Answer":"C","Sorting":9}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871831,"TestType":"ATEST","Title":"输液反应中属于医院内感染的是（   ）","Explain":"","TestPoint":"","SelectedItem":["由液体或输液通路中的毒素引起的发热","由于液体被细菌污染引起的发热","由于输注液体中的药物引起的发热","由于输液管中的内毒素引起的发热","由于输注的液体中含有热源物质引起的发热"],"Answer":"B","Sorting":10}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871837,"TestType":"ATEST","Title":"有关医院内感染预防与控制的概念，错误的是（   ）","Explain":"","TestPoint":"","SelectedItem":["部分医院内感染是可以预防的","洗手是预防医院内感染的重要措施","医院内感染一定是由于消毒隔离缺陷所致","内源性医院内感染是医院内感染的重要原因","滥用抗菌药物可致二重感染"],"Answer":"C","Sorting":16}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871839,"TestType":"ATEST","Title":"关于消毒灭菌方法的选择，错误的是（   ）","Explain":"","TestPoint":"","SelectedItem":["耐热耐湿的物品首选压力蒸气灭菌法灭菌","手术器具与物品首选压力蒸气灭菌法灭菌","消毒首选物理方法，不能用物理方法消毒时选择化学消毒方法消毒","不耐热的物品如各种导管、精密仪器、人工移植物可以选择化学灭菌方法，如环氧乙烷灭菌","化学灭菌剂浸泡灭菌方便实用，应加以推广"],"Answer":"E","Sorting":18}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871840,"TestType":"ATEST","Title":"下列有关护理工作的描述，不正确的是（   ）","Explain":"","TestPoint":"","SelectedItem":["各种治疗、护理、换药操作应按清洁伤口、感染伤口、隔离伤口依次进行","起封抽吸的各种溶媒超过36小时不得使用，最好采用大包装","无菌物品必须一人一用一灭菌","灭菌物品提倡使用小包装，无菌棉球或纱布罐一经打开，使用时间不得超过24小时","治疗室、处置室布局合理，清洁区、污染区分区明确"],"Answer":"B","Sorting":19}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871881,"TestType":"ATEST","Title":"下列消毒剂中属高水平消毒剂的有（   ）","Explain":"","TestPoint":"","SelectedItem":["戊二醛","络合碘","苯扎溴胺","乙醇","碘酊"],"Answer":"A","Sorting":5}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871882,"TestType":"ATEST","Title":"关于医院内感染知识培训，错误的叙述是（   ）","Explain":"","TestPoint":"","SelectedItem":["培训内容包括管理知识和专业知识","培训对象包括管理、医务、工勤人员","非专职人员每年不少于2小时培训","进修医师必须培训","实习医师必须培训"],"Answer":"C","Sorting":6}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871888,"TestType":"ATEST","Title":"下列概念中不正确的是（   ）","Explain":"","TestPoint":"","SelectedItem":["医院内感染发病率是指一定时间内住院病人中发生医院内感染新发病例的频率","医院内感染暴发是指在某医院、某科室的住院病人中短时间内、突然发生许多医院内感染病例的现象","医院内感染流行是指某医院、某科室医院内感染发病率显著超过历年散发发病率水平","医院内感染散发是指医院内感染在某医院或某地区住院病人中历年的一般发病率水平","医院内感染的流行趋势是指医院内感染持续流行"],"Answer":"E","Sorting":12}',
    Style: "A型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859318,"TestType":"XTEST","Title":"道德起源的理论有(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["实践道德论","天赋道德论","人的自然本性论","心理道德论","”神启论”"],"Answer":"ABD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859322,"TestType":"XTEST","Title":"医学人道观、人权观的核心内容包括(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["尊重病人的生命","尊重病人的人格","尊重病人的家属","尊重病人平等的医疗权利","尊重病人的习惯"],"Answer":"ABD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859363,"TestType":"XTEST","Title":"病人的权利包括(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["基本医疗权","保护隐私权","要求赔偿权","要求”安乐死”权","知情同意权"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859782,"TestType":"XTEST","Title":"输血可以引起哪些感染(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["梅毒","丙型病毒性肝炎","弓形虫病","艾滋病","巨细胞病毒感染"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859783,"TestType":"XTEST","Title":"属于高度危险物品的有(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["手术器械","心导管","听诊器","体温表","压舌板"],"Answer":"AB"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859784,"TestType":"XTEST","Title":"医院应每月对下列哪些科室进行环境卫生学监测(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["手术室、供应室无菌区、治疗室、换药室","产房、母婴室、新生儿病房","重症监护室(ICU)","骨髓移植病房、血液病房、血液透析室","传染病房"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859785,"TestType":"XTEST","Title":"医院感染管理委员会的主要职责包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据有关政策法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859786,"TestType":"XTEST","Title":"有关外科手术切口感染的危险因素的描述，正确的是(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["术前住院时间长，感染危险性低","术前使用抗生素时间长，感染危险性高","侵入手术切口的细菌毒力强，感染危险性高","手术部位剃毛比剪毛的感染危险性低","术前使用抗生素时间短，感染危险性高"],"Answer":"BC"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861059,"TestType":"XTEST","Title":"为了使医疗体育更为科学化、定量化和个体化，运动处方必须包括(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["运动的种类","运动的强度","运动的次数","运动的时间","运动的方法"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861061,"TestType":"XTEST","Title":"磁场的主要治疗作用包括(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["消炎作用","消肿作用","镇痛、镇静作用","止咳、平喘作用","磁处理后的水有排石作用"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861124,"TestType":"XTEST","Title":"引起疼痛的原因包括(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["骨骼肌痉挛，软组织牵拉","痛觉神经末梢受到各种刺激（力学、电、冷热、化学、细菌）","脊髓休克","组织缺血，浆膜组织炎症水肿","血管炎症、膨胀收缩或被牵拉"],"Answer":"ABDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871402,"TestType":"XTEST","Title":"常用的康复治疗方法有（   ）","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["物理疗法","作业疗法","言语疗法","心理辅导","药物治疗"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871846,"TestType":"XTEST","Title":"属于医院内感染高度危险物品的有（   ）","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["手术器械","心导管","听诊器","体温表","压舌板"],"Answer":"AB"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871847,"TestType":"XTEST","Title":"医院应每月对下列哪些科室进行环境卫生学监测（   ）","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["手术室、供应室无菌区、治疗室、换药室","重症监护室(ICU)","产房、母婴室、新生儿病房","骨髓移植病房、血液病房、血液透析室","传染病房"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871902,"TestType":"XTEST","Title":"有关医院内医疗废物的处置正确的是（   ）","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["在废物产生护理单元进行分类收集","由专人定期在各分类收集点收集、转运医疗废物","放射性废物按放射防护条例的规定处置","医院应设置医疗废物暂存点","混有医疗废物的生活垃圾按医疗废物处置"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859326,"TestType":"XTEST","Title":"下述各项中，哪些是健康的人格特点(   )","Explain":"略","TestPoint":"","Sorting":8,"SelectedItem":["自我扩展的能力","与他人交往的能力","情绪上有安全感和自我认可","定向统一的人生观","感情丰富多彩"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859362,"TestType":"XTEST","Title":"医学道德情感包括(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["同情感","责任感","事业感","成就感","愧疚感"],"Answer":"ABC"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859365,"TestType":"XTEST","Title":"人类生态环境保护的道德原则包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["尊重自然的道德原则","合理利用资源的道德原则","系统综合的道德原则","同步效应的道德原则","面向未来的道德原则"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859368,"TestType":"XTEST","Title":"情感按其内容一般分为哪些方面(   )","Explain":"略","TestPoint":"","Sorting":6,"SelectedItem":["道德感","理智感","美感","同情感","正义感"],"Answer":"ABDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859373,"TestType":"XTEST","Title":"道德的含义包括(   )","Explain":"略","TestPoint":"","Sorting":11,"SelectedItem":["道德水平","道德意识","道德范围","道德伦理","道德实践"],"Answer":"BCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859782,"TestType":"XTEST","Title":"输血可以引起哪些感染(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["梅毒","丙型病毒性肝炎","弓形虫病","艾滋病","巨细胞病毒感染"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859785,"TestType":"XTEST","Title":"医院感染管理委员会的主要职责包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据有关政策法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859786,"TestType":"XTEST","Title":"有关外科手术切口感染的危险因素的描述，正确的是(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["术前住院时间长，感染危险性低","术前使用抗生素时间长，感染危险性高","侵入手术切口的细菌毒力强，感染危险性高","手术部位剃毛比剪毛的感染危险性低","术前使用抗生素时间短，感染危险性高"],"Answer":"BC"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859840,"TestType":"XTEST","Title":"在医院环境卫生学监测中，对致病性微生物监测的规定正确的是(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["空气、医务人员手、物表不得检出乙型溶血性链球菌","空气、医务人员手、物表不得检出金黄色葡萄球菌及其他致病性微生物","空气、医务人员手、物表在可疑污染情况下进行相应指标的检测","空气、物表、医务人员手不得检出铜绿假单胞菌","母婴室、早产儿室、婴儿室、新生儿及儿科病房的物体表面和医护人员手上不得检出沙门菌"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871403,"TestType":"XTEST","Title":"恶性肿瘤康复治疗的主要目的包括（   ）","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["增进食欲","延长存活时间","消除心理障碍","改善功能","提高生活质量"],"Answer":"BCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871848,"TestType":"XTEST","Title":"医院的医院感染管理委员会的主要职责包括（   ）","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据国家有关政策、法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学检测监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871900,"TestType":"XTEST","Title":"医院内感染，下列叙述中可以发生在（   ）","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["门诊病人","住院病人","医务人员","探视者","陪护人员"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871903,"TestType":"XTEST","Title":"在医院环境卫生学监测中，对致病性微生物监测的规定正确的是（   ）．","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["空气、医务人员手、物表不得检出乙型溶血性链球菌","空气、医务人员手、物表不得检出金黄色葡萄球菌及其他致病性微生物","空气、医务人员手、物表在可疑污染情况下进行相应指标的检测","空气、物表、医务人员手不得检出铜绿假单胞菌","母婴室、早产儿室、婴儿室、新生儿及儿科病房的物体表面和医护人员手上不得检出沙门菌属"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859320,"TestType":"XTEST","Title":"医学伦理学研究的对象包括(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["病人与病人之间的关系","医护人员相互之间的关系","医务人员与病人及其家属的关系","医务人员与社会的关系","病人与社会之间的关系"],"Answer":"BCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859323,"TestType":"XTEST","Title":"下述哪些属于气质分型中的典型心理特征(   )","Explain":"略","TestPoint":"","Sorting":5,"SelectedItem":["胆汁质","多血质","偏执质","黏液质","抑郁质"],"Answer":"ABDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859324,"TestType":"XTEST","Title":"按照记忆的分类，下述哪些属于记忆的内容(   )","Explain":"略","TestPoint":"","Sorting":6,"SelectedItem":["形象记忆","强迫记忆","运动记忆","逻辑记忆","情绪记忆"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859326,"TestType":"XTEST","Title":"下述各项中，哪些是健康的人格特点(   )","Explain":"略","TestPoint":"","Sorting":8,"SelectedItem":["自我扩展的能力","与他人交往的能力","情绪上有安全感和自我认可","定向统一的人生观","感情丰富多彩"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859328,"TestType":"XTEST","Title":"下列何者是抑郁病人的常见表现(   )","Explain":"略","TestPoint":"","Sorting":10,"SelectedItem":["兴趣减退甚至丧失","无助感","精神疲劳萎靡","易怒倾向","自责自罪"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859782,"TestType":"XTEST","Title":"输血可以引起哪些感染(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["梅毒","丙型病毒性肝炎","弓形虫病","艾滋病","巨细胞病毒感染"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859786,"TestType":"XTEST","Title":"有关外科手术切口感染的危险因素的描述，正确的是(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["术前住院时间长，感染危险性低","术前使用抗生素时间长，感染危险性高","侵入手术切口的细菌毒力强，感染危险性高","手术部位剃毛比剪毛的感染危险性低","术前使用抗生素时间短，感染危险性高"],"Answer":"BC"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861121,"TestType":"XTEST","Title":"肌力检查的禁忌证有(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["严重疼痛","严重关节积液、红肿","关节极不稳定","软组织损伤刚愈合","骨折愈合后"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871403,"TestType":"XTEST","Title":"恶性肿瘤康复治疗的主要目的包括（   ）","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["增进食欲","延长存活时间","消除心理障碍","改善功能","提高生活质量"],"Answer":"BCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871846,"TestType":"XTEST","Title":"属于医院内感染高度危险物品的有（   ）","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["手术器械","心导管","听诊器","体温表","压舌板"],"Answer":"AB"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871849,"TestType":"XTEST","Title":"有关外科手术切口感染的危险因素的描述，下列哪些是正确的（   ）","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["术前住院时间长，感染危险性低","术前使用抗生素时间长，感染危险性高","侵入手术切口的细菌毒力强，感染危险性高","手术部位剃毛比剪毛的感染危险性低","术前使用抗生素时间短，感染危险性高"],"Answer":"BC"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871900,"TestType":"XTEST","Title":"医院内感染，下列叙述中可以发生在（   ）","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["门诊病人","住院病人","医务人员","探视者","陪护人员"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871903,"TestType":"XTEST","Title":"在医院环境卫生学监测中，对致病性微生物监测的规定正确的是（   ）．","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["空气、医务人员手、物表不得检出乙型溶血性链球菌","空气、医务人员手、物表不得检出金黄色葡萄球菌及其他致病性微生物","空气、医务人员手、物表在可疑污染情况下进行相应指标的检测","空气、物表、医务人员手不得检出铜绿假单胞菌","母婴室、早产儿室、婴儿室、新生儿及儿科病房的物体表面和医护人员手上不得检出沙门菌属"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859323,"TestType":"XTEST","Title":"下述哪些属于气质分型中的典型心理特征(   )","Explain":"略","TestPoint":"","Sorting":5,"SelectedItem":["胆汁质","多血质","偏执质","黏液质","抑郁质"],"Answer":"ABDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859363,"TestType":"XTEST","Title":"病人的权利包括(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["基本医疗权","保护隐私权","要求赔偿权","要求”安乐死”权","知情同意权"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859784,"TestType":"XTEST","Title":"医院应每月对下列哪些科室进行环境卫生学监测(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["手术室、供应室无菌区、治疗室、换药室","产房、母婴室、新生儿病房","重症监护室(ICU)","骨髓移植病房、血液病房、血液透析室","传染病房"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859785,"TestType":"XTEST","Title":"医院感染管理委员会的主要职责包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据有关政策法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859838,"TestType":"XTEST","Title":"预防免疫功能低下病人发生医院内感染，正确的方法是(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["注射相关疫苗","广谱抗生素肠道去污染","治疗潜在性感染病灶","保护性隔离","保护皮肤黏膜的完整性"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859840,"TestType":"XTEST","Title":"在医院环境卫生学监测中，对致病性微生物监测的规定正确的是(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["空气、医务人员手、物表不得检出乙型溶血性链球菌","空气、医务人员手、物表不得检出金黄色葡萄球菌及其他致病性微生物","空气、医务人员手、物表在可疑污染情况下进行相应指标的检测","空气、物表、医务人员手不得检出铜绿假单胞菌","母婴室、早产儿室、婴儿室、新生儿及儿科病房的物体表面和医护人员手上不得检出沙门菌"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859841,"TestType":"XTEST","Title":"关于医疗用品的卫生标准，下列哪些是正确的(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["进入人体无菌组织、器官或接触破损皮肤、黏膜的医疗用品必须无菌","接触黏膜的医疗用品细菌菌落总数应≤20cfu/g或100cm[ImgDir_SJSTJ_YJFCDEB/~2.gif]，不得检出致病性微生物","接触皮肤的医疗用品细菌菌落总数应≤200cfu/g或100cm[ImgDir_SJSTJ_YJFCDEB/~2.gif]，不得检出致病性微生物","使用中消毒剂细菌菌落总数应≤100cfu/mL，不得检出致病性微生物","无菌器械保存液必须无菌"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861062,"TestType":"XTEST","Title":"肌力测定的意义包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["了解损伤和疾病导致肌力减退的范围","了解损伤和疾病导致肌力减退的程度","评定治疗效果","制定治疗方案依据","判定预后"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861122,"TestType":"XTEST","Title":"影响关节活动度测定的因素有(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["不良体位","测量工具放置不当和选择的参考点不准","病人缺乏理解与合作","疼痛","男女老少不受影响"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871404,"TestType":"XTEST","Title":"磁场的主要治疗作用包括（   ）","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["消炎作用","消肿作用","镇痛、镇静作用","止咳、平喘作用","磁处理后的水有排石作用"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871845,"TestType":"XTEST","Title":"输血可以引起哪些感染（   ）","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["梅毒","丙型病毒性肝炎","弓形虫病","艾滋病","巨细胞病毒感染"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871846,"TestType":"XTEST","Title":"属于医院内感染高度危险物品的有（   ）","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["手术器械","心导管","听诊器","体温表","压舌板"],"Answer":"AB"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859321,"TestType":"XTEST","Title":"生命伦理学的研究领域包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["理论生命伦理学","临床生命伦理学","道德生命伦理学","文化生命伦理学","未来生命伦理学"],"Answer":"ABD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859324,"TestType":"XTEST","Title":"按照记忆的分类，下述哪些属于记忆的内容(   )","Explain":"略","TestPoint":"","Sorting":6,"SelectedItem":["形象记忆","强迫记忆","运动记忆","逻辑记忆","情绪记忆"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859327,"TestType":"XTEST","Title":"以下哪些属于老年病人常见的心理反应(   )","Explain":"略","TestPoint":"","Sorting":9,"SelectedItem":["自尊心理","否认心理","恐惧心理","幼稚心理","抑郁心理"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859328,"TestType":"XTEST","Title":"下列何者是抑郁病人的常见表现(   )","Explain":"略","TestPoint":"","Sorting":10,"SelectedItem":["兴趣减退甚至丧失","无助感","精神疲劳萎靡","易怒倾向","自责自罪"],"Answer":"ABCE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859370,"TestType":"XTEST","Title":"下列哪些疾病属心身障碍性疾病(   )","Explain":"略","TestPoint":"","Sorting":8,"SelectedItem":["斑秃","艾滋病","消化性溃疡","偏头痛","原发性高血压"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859371,"TestType":"XTEST","Title":"在护患关系中护士扮演的角色包括(   )","Explain":"略","TestPoint":"","Sorting":9,"SelectedItem":["关怀和照顾的提供者角色","教师角色","咨询者角色","病人辩护人角色","变化促进者角色"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859782,"TestType":"XTEST","Title":"输血可以引起哪些感染(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["梅毒","丙型病毒性肝炎","弓形虫病","艾滋病","巨细胞病毒感染"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859785,"TestType":"XTEST","Title":"医院感染管理委员会的主要职责包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据有关政策法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859839,"TestType":"XTEST","Title":"有关医院内医疗废物的处置，正确的方法是(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["在废物产生护理单元进行分类收集","由专人定期在各分类收集点收集、转运医疗废物","医院应设置医疗废物暂存点","放射性废物按放射防护条例的规定处置","混有医疗废物的生活垃圾按医疗废物处置"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859841,"TestType":"XTEST","Title":"关于医疗用品的卫生标准，下列哪些是正确的(   )","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["进入人体无菌组织、器官或接触破损皮肤、黏膜的医疗用品必须无菌","接触黏膜的医疗用品细菌菌落总数应≤20cfu/g或100cm[ImgDir_SJSTJ_YJFCDEB/~2.gif]，不得检出致病性微生物","接触皮肤的医疗用品细菌菌落总数应≤200cfu/g或100cm[ImgDir_SJSTJ_YJFCDEB/~2.gif]，不得检出致病性微生物","使用中消毒剂细菌菌落总数应≤100cfu/mL，不得检出致病性微生物","无菌器械保存液必须无菌"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861062,"TestType":"XTEST","Title":"肌力测定的意义包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["了解损伤和疾病导致肌力减退的范围","了解损伤和疾病导致肌力减退的程度","评定治疗效果","制定治疗方案依据","判定预后"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871402,"TestType":"XTEST","Title":"常用的康复治疗方法有（   ）","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["物理疗法","作业疗法","言语疗法","心理辅导","药物治疗"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871845,"TestType":"XTEST","Title":"输血可以引起哪些感染（   ）","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["梅毒","丙型病毒性肝炎","弓形虫病","艾滋病","巨细胞病毒感染"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871848,"TestType":"XTEST","Title":"医院的医院感染管理委员会的主要职责包括（   ）","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据国家有关政策、法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学检测监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859327,"TestType":"XTEST","Title":"以下哪些属于老年病人常见的心理反应(   )","Explain":"略","TestPoint":"","Sorting":9,"SelectedItem":["自尊心理","否认心理","恐惧心理","幼稚心理","抑郁心理"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859365,"TestType":"XTEST","Title":"人类生态环境保护的道德原则包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["尊重自然的道德原则","合理利用资源的道德原则","系统综合的道德原则","同步效应的道德原则","面向未来的道德原则"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859368,"TestType":"XTEST","Title":"情感按其内容一般分为哪些方面(   )","Explain":"略","TestPoint":"","Sorting":6,"SelectedItem":["道德感","理智感","美感","同情感","正义感"],"Answer":"ABDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859371,"TestType":"XTEST","Title":"在护患关系中护士扮演的角色包括(   )","Explain":"略","TestPoint":"","Sorting":9,"SelectedItem":["关怀和照顾的提供者角色","教师角色","咨询者角色","病人辩护人角色","变化促进者角色"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859372,"TestType":"XTEST","Title":"临床诊治工作的基本道德原则包括(   )","Explain":"略","TestPoint":"","Sorting":10,"SelectedItem":["及时原则","有效原则","择优原则","准确原则","自主原则"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859782,"TestType":"XTEST","Title":"输血可以引起哪些感染(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["梅毒","丙型病毒性肝炎","弓形虫病","艾滋病","巨细胞病毒感染"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859784,"TestType":"XTEST","Title":"医院应每月对下列哪些科室进行环境卫生学监测(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["手术室、供应室无菌区、治疗室、换药室","产房、母婴室、新生儿病房","重症监护室(ICU)","骨髓移植病房、血液病房、血液透析室","传染病房"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859785,"TestType":"XTEST","Title":"医院感染管理委员会的主要职责包括(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据有关政策法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859838,"TestType":"XTEST","Title":"预防免疫功能低下病人发生医院内感染，正确的方法是(   )","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["注射相关疫苗","广谱抗生素肠道去污染","治疗潜在性感染病灶","保护性隔离","保护皮肤黏膜的完整性"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859839,"TestType":"XTEST","Title":"有关医院内医疗废物的处置，正确的方法是(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["在废物产生护理单元进行分类收集","由专人定期在各分类收集点收集、转运医疗废物","医院应设置医疗废物暂存点","放射性废物按放射防护条例的规定处置","混有医疗废物的生活垃圾按医疗废物处置"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861059,"TestType":"XTEST","Title":"为了使医疗体育更为科学化、定量化和个体化，运动处方必须包括(   )","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["运动的种类","运动的强度","运动的次数","运动的时间","运动的方法"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861061,"TestType":"XTEST","Title":"磁场的主要治疗作用包括(   )","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["消炎作用","消肿作用","镇痛、镇静作用","止咳、平喘作用","磁处理后的水有排石作用"],"Answer":"ABCDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861123,"TestType":"XTEST","Title":"关节活动度检查的注意事项有(   )","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["防止邻近关节的替代动作","需测关节的主动活动范围和被动活动范围","与健侧对比","允许有3°～5°的误差","按摩、运动后立即进行"],"Answer":"ABCD"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871848,"TestType":"XTEST","Title":"医院的医院感染管理委员会的主要职责包括（   ）","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["依据国家有关政策、法规，制定全院控制医院内感染规划、管理制度，并组织实施","定期总结、分析细菌学检测监测资料，向有关部门反馈，并向全院公布","根据《综合医院建筑标准》有关卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见","对医院感染管理科拟定的全院医院内感染管理工作计划进行审定，对其工作进行考评","建立会议制度，定期研究、协调和解决有关医院内感染管理方面的重大事项，遇有紧急问题随时召开"],"Answer":"ACDE"}',
    Style: "X型题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859340,"TestType":"PDTEST","Title":"医学道德是永恒不变的。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":1}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859347,"TestType":"PDTEST","Title":"原发性高血压、荨麻疹、斑秃、偏头痛都是与心身障碍有关的疾病。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":8}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859388,"TestType":"PDTEST","Title":"确定病人死亡的医师不得同时是实施该死亡病人器官移植的手术者。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":5}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861079,"TestType":"PDTEST","Title":"物理疗法中各种物理因子对人体的直接作用是指直接引起局部组织的生物物理和生物化学的变化；间接作用指通过热、电化学或光化学的变化所引起的体液改变、神经反射、经络穴位发挥的作用。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":5}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861149,"TestType":"PDTEST","Title":"紫外线照射不但可以治疗急性浅表性炎症，还可以治疗系统性红斑狼疮、急性湿疹。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":9}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871413,"TestType":"PDTEST","Title":"康复护理技术应包括基础护理技术和康复护理专业技术。康复护士只有康复护理的知识是不够的，还必须学习运动疗法、作业疗法、心理疗法等方面的知识。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":1}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871419,"TestType":"PDTEST","Title":"被动运动时，运动要达到有疼痛才能起到治疗效果。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":7}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871864,"TestType":"PDTEST","Title":"口腔科修复技工室的印模、蜡块、石膏模型及各种修复体应使用中效以上消毒方法进行消毒。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":8}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871913,"TestType":"PDTEST","Title":"导管介入治疗室的一次性使用导管可以重复使用，传染病病人用过的导管不得重复使用。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":3}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871918,"TestType":"PDTEST","Title":"治疗室、配餐室、病室、厕所等应分别设置专用拖布，标记明确，分开清洗，悬挂晾干，定期消毒。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":8}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859802,"TestType":"PDTEST","Title":"内镜的消毒须使用高效消毒剂，如2%戊二醛消毒浸泡30分钟，消毒后用无菌蒸馏水充分冲洗。内镜、活检钳的灭菌首选压力蒸气灭菌，也可用环氧乙烷灭菌或2%戊二醛浸泡10小时。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":9}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859855,"TestType":"PDTEST","Title":"没有明确潜伏期的感染，发生在入院48小时以后的即医院内感染。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":6}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859858,"TestType":"PDTEST","Title":"医院使用的锐器（针头、穿刺针等）用后应放入防渗漏、耐刺的容器内，然后进行无害化处理。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":9}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861140,"TestType":"PDTEST","Title":"等长运动即肌肉收缩时张力明显增加，但关节不产生肉眼可见的运动。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":0}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861142,"TestType":"PDTEST","Title":"运动治疗量是指运动治疗中的总负荷量，其大小取决于运动治疗的强度、频率和治疗的总时间。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":2}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861146,"TestType":"PDTEST","Title":"骨质疏松的特征表现为低骨量、骨组织结构破坏、骨脆性增加，易骨折。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":6}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871910,"TestType":"PDTEST","Title":"碘酊、乙醇应密闭保存，每周更换2次，容器每周灭菌2次。无菌敷料罐应每天更换并灭菌；置于无菌储槽中的灭菌物品（棉球、纱布等）一经打开，使用时间不得超过24小时，提倡使用小包装。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":0}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859384,"TestType":"PDTEST","Title":"性病病人有权要求医务人员为其保密。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":1}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859390,"TestType":"PDTEST","Title":"干细胞研究目标，在于治疗严重的、难治的疾病，这种人类胚胎干细胞研究，应予支持。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":7}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859854,"TestType":"PDTEST","Title":"出院后1个月内的手术切口感染属医院感染。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":5}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859857,"TestType":"PDTEST","Title":"治疗室、配餐室、病室、厕所等应分别设置专用拖布，标记明确，分开清洗，悬挂晾干，定期消毒。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":8}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861081,"TestType":"PDTEST","Title":"小剂量紫外线和小剂量的激光促进伤口愈合加速作用的机制，主要通过上皮细胞、细胞合成代谢加速来促进愈合。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":7}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871416,"TestType":"PDTEST","Title":"女性病人月经期不是超短波的禁忌证。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":4}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871418,"TestType":"PDTEST","Title":"助力运动是以助力为主，主动运动为辅的运动。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":6}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871860,"TestType":"PDTEST","Title":"医院内感染就是交叉感染。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":4}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871862,"TestType":"PDTEST","Title":"抽出的药液、开启的静脉输入用无菌液体须注明时间，超过2小时后不得使用；启封抽吸的各种溶媒超过24小时不得使用，最好采用小包装。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":6}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871915,"TestType":"PDTEST","Title":"出院后1个月内的手术切口感染属医院内感染。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":5}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859794,"TestType":"PDTEST","Title":"传染性非典型肺炎是我国法定管理的传染病，属乙类传染病。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":1}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859798,"TestType":"PDTEST","Title":"在条件不够如时间紧时，高度危险物品可以只高水平消毒即可使用。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":5}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859853,"TestType":"PDTEST","Title":"传染病房应严格执行各病种消毒隔离制度。医务人员在诊查不同病种的病人时，应严格洗手与手消毒。教育病人食品、物品不混用，不互串病房。病人用过的医疗器械、用品等均应先消毒、后清洗，然后根据要求消毒或灭菌，病人出院后严格执行终末消毒。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":4}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861075,"TestType":"PDTEST","Title":"助力运动是以助力为主，主动运动为辅的运动。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":1}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861145,"TestType":"PDTEST","Title":"神经肌肉电刺激疗法，禁用于下运动神经元引起的瘫痪。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":5}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861148,"TestType":"PDTEST","Title":"在直流电疗法中，阳极为镇静，阴极为兴奋。如增加电流量时，则作用相反。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":8}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871859,"TestType":"PDTEST","Title":"病人咳嗽、咳痰，痰培养阳性，应诊断为医院内感染。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":3}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871865,"TestType":"PDTEST","Title":"内镜的消毒须使用高效消毒剂，如2%戊二醛消毒浸泡30分钟，消毒后用无菌蒸馏水充分冲洗。内镜、活检钳的灭菌首选压力蒸气灭菌，也可用环氧乙烷灭菌或2%戊二醛浸泡10小时。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":9}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859343,"TestType":"PDTEST","Title":"对确实患有严重遗传性疾病的人，可以强制实施绝育。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":4}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859386,"TestType":"PDTEST","Title":"医师向孕妇透露胎儿的性别不属维法行为。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":3}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859391,"TestType":"PDTEST","Title":"对于患有晚期绝症的病人，只要病人和家属提出要求，医师可以协助实行安乐死。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":8}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859856,"TestType":"PDTEST","Title":"住院病人只要尿培养出细菌，就可诊断为医院内尿路感染。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":7}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861080,"TestType":"PDTEST","Title":"短波、超短波电磁场作用深度可达骨骼，而直流电、低中频电流主要在皮肤层，其次为肌层。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":6}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871421,"TestType":"PDTEST","Title":"目前认为激光对生物体的作用主要有热效应、电磁效应、光化效应、机械效用。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":9}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871857,"TestType":"PDTEST","Title":"传染性非典型肺炎是我国法定管理的传染病，属乙类传染病。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":1}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871858,"TestType":"PDTEST","Title":"医院环境监测中的致病性微生物的检测是指乙型溶血性链球菌、金黄色葡萄球菌及其他致病性微生物，并在可疑污染情况下进行相应指标的检测。母婴室、早产儿室、婴儿室、新生儿及儿科病房的物体表面和医护人员的手还不得检出沙门菌。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":2}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871863,"TestType":"PDTEST","Title":"血液净化室工作人员应定期体格检查，操作时必须注意消毒隔离，加强个人防护，必要时注射乙型肝炎疫苗。应对病人常规进行血液净化前肝功能、肝炎病原学等实验室检查。（   ）","Explain":"略","TestPoint":"","Answer":"对","Sorting":7}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859346,"TestType":"PDTEST","Title":"病人有接受或拒绝或选择治疗方案的权利。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":7}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859383,"TestType":"PDTEST","Title":"医学是没有阶段性的。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":0}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859385,"TestType":"PDTEST","Title":"在医学人体实验中，对照实验使用安慰剂和进行双盲法试验，不必征得病人的同意。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":2}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859389,"TestType":"PDTEST","Title":"根据我国相关法规的规定，对于自身不能怀孕的妇女，医师可协助实行代孕。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":6}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859801,"TestType":"PDTEST","Title":"口腔科修复技工室的印模、蜡块、石膏模型及各种修复体应使用中效以上消毒方法进行消毒。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":8}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859849,"TestType":"PDTEST","Title":"碘酊、乙醇应密闭保存，每周更换2次，容器每周灭菌2次。无菌敷料罐应每天更换并灭菌。置于无菌储槽中的灭菌物品（棉球、纱布等）一经打开，使用时间不得超过24小时，提倡使用小包装。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":0}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861078,"TestType":"PDTEST","Title":"跑步、爬山、划船、骑自行车、游泳是一种无氧训练。(   )","Explain":"略","TestPoint":"","Answer":"错","Sorting":4}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861143,"TestType":"PDTEST","Title":"运动治疗的强度是运动处方中的定量化的核心。(   )","Explain":"略","TestPoint":"","Answer":"对","Sorting":3}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871911,"TestType":"PDTEST","Title":"在口腔科凡接触病人伤口和血液的器械（如手机、车针、扩大针、拔牙钳、挺子、凿子、手术刀、牙周刮治器、洁牙器等）和敷料每人用后均应消毒；常用的口腔科检查器、充填器、托盘等每人用后均应消毒。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":1}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871917,"TestType":"PDTEST","Title":"住院病人只要尿培养出细菌，就可诊断为医院内尿路感染。（   ）","Explain":"略","TestPoint":"","Answer":"错","Sorting":7}',
    Style: "判断题",
    errCount: 0,
    AlreadyStuCount: 1,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861117,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["热疗（超短波）","冷疗","深部脑刺激","射频","间动电疗"],"BTestItem":[{"ID":1543,"TestType":"ATEST","Title":"治疗顽固性三叉神经痛最佳方法可选用(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1544,"TestType":"ATEST","Title":"治疗急性软组织损伤(24小时之内)的最佳选择是(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861118,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":4,"SelectedItem":["提高过去相对无效形成通路和（或）突触效率（突触效率又取决于使用频率）","外周刺激的感觉反馈可促进功能恢复和帮助环境适应和生存，只有反复学习和训练","两者均是","两者均否"],"BTestItem":[{"ID":1545,"TestType":"ATEST","Title":"脑损伤功能训练的重要性在于(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1546,"TestType":"ATEST","Title":"完全性脊髓神经损伤功能训练是通过(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861119,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":5,"SelectedItem":["肌力3级以上","肌力2级","两者均可","两者均否"],"BTestItem":[{"ID":1547,"TestType":"ATEST","Title":"进行等速运动测定要有(   )","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1548,"TestType":"ATEST","Title":"徒手肌力测试(MMT)要有(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":1}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859835,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["0.5%碘伏","2%戊二醛","两者均是","两者均否"],"BTestItem":[{"ID":1287,"TestType":"ATEST","Title":"低效消毒剂(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1288,"TestType":"ATEST","Title":"高效消毒剂(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871842,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["必须无菌","细菌菌落总数应≤20cfu/g或≤20cfu/100cm[ImgDir_SJSTJ_YSFCDEB/~2.gif]，致病性微生物不得检出","细菌菌落总数应≤200cfu/g或≤200cfu/100cm[ImgDir_SJSTJ_YSFCDEB/~2.gif]，致病性微生物不得检出","细菌菌落总数应≤100cfu／mL，致病性微生物不得检出","细菌菌落总数应≤300cfu／mL，致病性微生物不得检出"],"BTestItem":[{"ID":1000799,"TestType":"ATEST","Title":"进入组织、器官或接触破损皮肤、黏膜的医疗用品（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000800,"TestType":"ATEST","Title":"接触黏膜的医疗用品（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000801,"TestType":"ATEST","Title":"接触皮肤的医疗用品（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":2},{"ID":1000802,"TestType":"ATEST","Title":"使用中的消毒剂（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":3}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859779,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["必须无菌","细菌菌落总数应≤20cfu/g或≤20cfu/100cm[ImgDir_SJSTJ_YJFCDEB/~2.gif]，致病性微生物不得检出","细菌菌落总数应≤200cfu/g或≤200cfu/100cm[ImgDir_SJSTJ_YJFCDEB/~2.gif]，致病性微生物不得检出","细菌菌落总数应≤100cfu/mL，致病性微生物不得检出","细菌菌落总数应≤300cfu/mL，致病性微生物不得检出"],"BTestItem":[{"ID":1268,"TestType":"ATEST","Title":"进入组织、器官或接触破损皮肤、黏膜的医疗用品的卫生标准是(   )","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1269,"TestType":"ATEST","Title":"接触黏膜的医疗用品的卫生标准是(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1270,"TestType":"ATEST","Title":"接触皮肤的医疗用品的卫生标准是(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":2},{"ID":1271,"TestType":"ATEST","Title":"使用中的消毒剂的卫生标准是(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":3}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871842,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["必须无菌","细菌菌落总数应≤20cfu/g或≤20cfu/100cm[ImgDir_SJSTJ_YSFCDEB/~2.gif]，致病性微生物不得检出","细菌菌落总数应≤200cfu/g或≤200cfu/100cm[ImgDir_SJSTJ_YSFCDEB/~2.gif]，致病性微生物不得检出","细菌菌落总数应≤100cfu／mL，致病性微生物不得检出","细菌菌落总数应≤300cfu／mL，致病性微生物不得检出"],"BTestItem":[{"ID":1000799,"TestType":"ATEST","Title":"进入组织、器官或接触破损皮肤、黏膜的医疗用品（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000800,"TestType":"ATEST","Title":"接触黏膜的医疗用品（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000801,"TestType":"ATEST","Title":"接触皮肤的医疗用品（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":2},{"ID":1000802,"TestType":"ATEST","Title":"使用中的消毒剂（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":3}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859834,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["A","B","C","D","E"],"BTestItem":[{"ID":1282,"TestType":"ATEST","Title":"急性HBV感染早期，HBV复制活跃者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1283,"TestType":"ATEST","Title":"急性或慢性乙型病毒性肝炎，HBV复制活跃者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1284,"TestType":"ATEST","Title":"HBV复制停止者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":2},{"ID":1285,"TestType":"ATEST","Title":"接种乙型肝炎疫苗后者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[E]","Sorting":3},{"ID":1286,"TestType":"ATEST","Title":"HBsAg、HBeAg变异者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":4}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 5,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861058,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":5,"SelectedItem":["一级预防","二级预防","两者均是","两者均否"],"BTestItem":[{"ID":1532,"TestType":"ATEST","Title":"认真进行预防接种，服预防药丸，预防小儿麻痹症发生属(   )","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1533,"TestType":"ATEST","Title":"对已有小儿麻痹后遗症的病人采用适当的矫形手术治疗，防止畸形的加重属(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6861114,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["残障","残疾","病损","器官残疾","心肺残疾"],"BTestItem":[{"ID":1534,"TestType":"ATEST","Title":"男，9岁，幼时患小儿麻痹症，右下肢轻度短缩，跛行，轻度肌萎缩，肌力>4级，能独自行走，生活自理。属以上何种类型(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":0},{"ID":1535,"TestType":"ATEST","Title":"男，54岁，4年前因脑出血而致右侧偏瘫，虽经积极治疗，现仍需扶拐步行，上下楼梯困难，语言交谈困难，听、视力尚可。属以上何种类型(   )","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":1},{"ID":1536,"TestType":"ATEST","Title":"女，6岁，出生时发现上唇裂，2岁时已行手术矫治，讲话有轻度口吃。属以上何种类型(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":2}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6859834,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["A","B","C","D","E"],"BTestItem":[{"ID":1282,"TestType":"ATEST","Title":"急性HBV感染早期，HBV复制活跃者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1283,"TestType":"ATEST","Title":"急性或慢性乙型病毒性肝炎，HBV复制活跃者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1284,"TestType":"ATEST","Title":"HBV复制停止者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":2},{"ID":1285,"TestType":"ATEST","Title":"接种乙型肝炎疫苗后者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[E]","Sorting":3},{"ID":1286,"TestType":"ATEST","Title":"HBsAg、HBeAg变异者，HBV标志物检测结果应符合(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":4}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 5,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871896,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["国家医院感染管理咨询专家委员会","省医院感染管理专家咨询委员会","各级医院的医院感染管理委员会","医院感染管理科","临床科室医院感染管理小组"],"BTestItem":[{"ID":1000808,"TestType":"ATEST","Title":"根据《综合医院建筑标准》有关的卫生学标准及预防医院内感染的要求，对医院的改建、扩建和新建提出建设性意见的应是（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000809,"TestType":"ATEST","Title":"对医院发生的医院内感染流行、暴发流行进行调查分析，提出控制措施，并组织实施的应是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1},{"ID":1000810,"TestType":"ATEST","Title":"监督、指导医师和医技人员严格执行无菌技术操作规程，合理应用抗感染药，实施对一次性医疗用品的管理等有关医院内感染管理的制度的应是（   ）","Explain":"略","TestPoint":"","Answer":"[E]","Sorting":2},{"ID":1000811,"TestType":"ATEST","Title":"对本地区的医院内感染管理进行技术指导的应是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":3},{"ID":1000812,"TestType":"ATEST","Title":"进行医院内感染管理的策略研究，为国家提供咨询意见的应是（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":4}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 5,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871399,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["一级预防","二级预防","三级预防","防截肢","防精神障碍"],"BTestItem":[{"ID":1000718,"TestType":"ATEST","Title":"认真进行预防接种，预防小儿麻痹症的发生。向广大群众和医务人员说明小儿麻痹症的发生发展过程，以便尽早发现、及时治疗，预防疾病的发展而引起的残疾属于（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000719,"TestType":"ATEST","Title":"对小儿麻痹后遗症的病人早期采用适当的矫形手术治疗，防止畸形的加重属于（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871400,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":3,"SelectedItem":["急性创伤","红斑狼疮","烧伤","结核","湿疹"],"BTestItem":[{"ID":1000720,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1000721,"TestType":"ATEST","Title":"紫外线治疗的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871841,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["A","B","C","D","E"],"BTestItem":[{"ID":1000793,"TestType":"ATEST","Title":"层流洁净病房（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000794,"TestType":"ATEST","Title":"烧伤病房（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000795,"TestType":"ATEST","Title":"重症监护病房（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":2},{"ID":1000796,"TestType":"ATEST","Title":"儿科病房（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":3},{"ID":1000797,"TestType":"ATEST","Title":"传染病门诊（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":4},{"ID":1000798,"TestType":"ATEST","Title":"婴儿室（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":5}]}',
    Style: "B型题",
    errCount: 0,
    AlreadyStuCount: 6,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871401,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["恶性肿瘤","活动性结核","两者均是","两者均否"],"BTestItem":[{"ID":1000722,"TestType":"ATEST","Title":"超声治疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000723,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871844,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["留置导尿管","气管切开","两者均是","两者均否"],"BTestItem":[{"ID":1000805,"TestType":"ATEST","Title":"医院内尿路感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000806,"TestType":"ATEST","Title":"医院内下呼吸道感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000807,"TestType":"ATEST","Title":"手术部位感染的常见诱因（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 6,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871898,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["0.5%碘伏","2%戊二醛","两者均是","两者均否"],"BTestItem":[{"ID":1000818,"TestType":"ATEST","Title":"低效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1000819,"TestType":"ATEST","Title":"高效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 4,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871899,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["使用过的注射针头","带血的敷料","两者均是","两者均否"],"BTestItem":[{"ID":1000820,"TestType":"ATEST","Title":"医疗废物为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000821,"TestType":"ATEST","Title":"损伤性废物为（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":1},{"ID":1000822,"TestType":"ATEST","Title":"生活垃圾为（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 6,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871401,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["恶性肿瘤","活动性结核","两者均是","两者均否"],"BTestItem":[{"ID":1000722,"TestType":"ATEST","Title":"超声治疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000723,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871844,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["留置导尿管","气管切开","两者均是","两者均否"],"BTestItem":[{"ID":1000805,"TestType":"ATEST","Title":"医院内尿路感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000806,"TestType":"ATEST","Title":"医院内下呼吸道感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000807,"TestType":"ATEST","Title":"手术部位感染的常见诱因（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871401,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["恶性肿瘤","活动性结核","两者均是","两者均否"],"BTestItem":[{"ID":1000722,"TestType":"ATEST","Title":"超声治疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000723,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871844,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["留置导尿管","气管切开","两者均是","两者均否"],"BTestItem":[{"ID":1000805,"TestType":"ATEST","Title":"医院内尿路感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000806,"TestType":"ATEST","Title":"医院内下呼吸道感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000807,"TestType":"ATEST","Title":"手术部位感染的常见诱因（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871401,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["恶性肿瘤","活动性结核","两者均是","两者均否"],"BTestItem":[{"ID":1000722,"TestType":"ATEST","Title":"超声治疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000723,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871843,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["醋酸氯己定","苯扎溴铵","两者均是","两者均否"],"BTestItem":[{"ID":1000803,"TestType":"ATEST","Title":"低效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000804,"TestType":"ATEST","Title":"高效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871844,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["留置导尿管","气管切开","两者均是","两者均否"],"BTestItem":[{"ID":1000805,"TestType":"ATEST","Title":"医院内尿路感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000806,"TestType":"ATEST","Title":"医院内下呼吸道感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000807,"TestType":"ATEST","Title":"手术部位感染的常见诱因（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871899,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["使用过的注射针头","带血的敷料","两者均是","两者均否"],"BTestItem":[{"ID":1000820,"TestType":"ATEST","Title":"医疗废物为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000821,"TestType":"ATEST","Title":"损伤性废物为（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":1},{"ID":1000822,"TestType":"ATEST","Title":"生活垃圾为（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871844,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["留置导尿管","气管切开","两者均是","两者均否"],"BTestItem":[{"ID":1000805,"TestType":"ATEST","Title":"医院内尿路感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000806,"TestType":"ATEST","Title":"医院内下呼吸道感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000807,"TestType":"ATEST","Title":"手术部位感染的常见诱因（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871898,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["0.5%碘伏","2%戊二醛","两者均是","两者均否"],"BTestItem":[{"ID":1000818,"TestType":"ATEST","Title":"低效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1000819,"TestType":"ATEST","Title":"高效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871899,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["使用过的注射针头","带血的敷料","两者均是","两者均否"],"BTestItem":[{"ID":1000820,"TestType":"ATEST","Title":"医疗废物为（   ）","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1000821,"TestType":"ATEST","Title":"损伤性废物为（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":1},{"ID":1000822,"TestType":"ATEST","Title":"生活垃圾为（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871844,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":1,"SelectedItem":["留置导尿管","气管切开","两者均是","两者均否"],"BTestItem":[{"ID":1000805,"TestType":"ATEST","Title":"医院内尿路感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[A]","Sorting":0},{"ID":1000806,"TestType":"ATEST","Title":"医院内下呼吸道感染的常见诱因是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1},{"ID":1000807,"TestType":"ATEST","Title":"手术部位感染的常见诱因（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":2}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 3,
    cwl: 0
  },
  {
    TestJSON:
      '{"ID":6871898,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["0.5%碘伏","2%戊二醛","两者均是","两者均否"],"BTestItem":[{"ID":1000818,"TestType":"ATEST","Title":"低效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":0},{"ID":1000819,"TestType":"ATEST","Title":"高效消毒剂是（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":1}]}',
    Style: "C型题",
    errCount: 0,
    AlreadyStuCount: 2,
    cwl: 0
  }
];

const ac = [
  {
    TestJSON:
      '{"ID":6859780,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":2,"SelectedItem":["醋酸氯己定","新洁尔灭","两者均是","两者均否"],"BTestItem":[{"ID":1272,"TestType":"ATEST","Title":"属于低效消毒剂的是(   )","Explain":"略","TestPoint":"","Answer":"[C]","Sorting":0},{"ID":1273,"TestType":"ATEST","Title":"属于高效消毒剂的是(   )","Explain":"略","TestPoint":"","Answer":"[D]","Sorting":1}]}',
    Style: "B型题",
    errCount: 4,
    AlreadyStuCount: 4,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6868937,"TestType":"ATEST","Title":"HIV主要攻击的细胞是（   ）","Explain":"","TestPoint":"","SelectedItem":["巨噬细胞","B细胞","CD8[ImgDir_SJSTJ_YSFCDEB/~+.gif]细胞","CD4[ImgDir_SJSTJ_YSFCDEB/~+.gif]细胞","T细胞"],"Answer":"D","Sorting":8}',
    Style: "A型题",
    errCount: 5,
    AlreadyStuCount: 5,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6859763,"TestType":"ATEST","Title":"医院污物的处理原则错误的是(   )","Explain":"","TestPoint":"","SelectedItem":["防止污染扩散","分类收集","分别处理","少量医疗垃圾可与生活垃圾一同处理","尽可能采用焚烧处理"],"Answer":"D","Sorting":5}',
    Style: "A型题",
    errCount: 2,
    AlreadyStuCount: 2,
    cwl: 100
  },
  {
    TestJSON:
      '{"ID":6871397,"TestType":"BTEST","MainTitle":"","Explain":"略","TestPoint":"","Sorting":0,"SelectedItem":["神经痛","小儿骨骺部","冠心病","关节僵直","带有心脏起搏器者"],"BTestItem":[{"ID":1000714,"TestType":"ATEST","Title":"超声治疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[B]","Sorting":0},{"ID":1000715,"TestType":"ATEST","Title":"超短波疗法的禁忌证为（   ）","Explain":"略","TestPoint":"","Answer":"[E]","Sorting":1}]}',
    Style: "B型题",
    errCount: 4,
    AlreadyStuCount: 4,
    cwl: 100
  }
];
export default ab;
